/**
 * Dropdown
 *
 * Basic functionality:
 * The first element is pre-checked and when any option is selected:
 * 1. We uncheck all inputs first,
 * 2. We grab the selected input element by its id, add a checked attribute to it.
 * 3. Fill the selected value in the hidden input.
 *
 * @package eBayAds
 */
( function ( $ ) {

	// The filter functionality should only be applied on 'Audience Home page'.
	if ( !$( 'body' ).hasClass( 'post-type-archive-audiences' ) ) {
		return;
	}

	const { postURLs } = window.audienceParams;

	class Filter {

		_selectedElId;
		_selectedInputEl;
		_submitButtonEl;

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			// Button filter.
			this.selectedBoxInputEls   = $( '.select-box__input' );
			this.buttonFilterContainer = $( '.button-filters' );
			this.buttonFilter          = $( '.button-filter' );

			// Dropdown filter.
			this.dropdownFilterContainer = $( '#dropdown-filter-container' );
			this.dropdownFilterHeadings  = this.dropdownFilterContainer.find( '.dropdown-filter-heading' );
			this.dropdownFilterDescs     = this.dropdownFilterContainer.find( '.dropdown-filter-description' );
			this.selectBox               = $( '#select-box-current' );
			this.options                 = $( '.select-box__option' );

			// Filter submit.
			this.submitButtonEl = $( '#filter-submit' );

			// Hidden input here holds the selected value.
			this.hiddenInput = $( '#selected-input-val' );

			this.addEvents();
		}

		addEvents() {
			// Button Events.
			this.buttonFilter.on( 'click', ( event ) => this.openFilterSelection( event ) );

			// Filter Events
			this.selectBox.on( 'click', ( event ) => this.toggleDropdown( event ) );
			this.options.on( 'click', ( event ) => this.selectOption( event ) );
		}

		/**
		 * Open filter selection.
		 */
		openFilterSelection( event ) {

			event.stopPropagation();

			// Add 'filter-open' class to filter main container, so that bottom margin can be controlled, when the filter section is not in view.
			this.buttonFilterContainer.addClass( 'filter-open' );

			const targetEl = $( event.target ).hasClass( 'button-filter' ) ? $( event.target ) : $( event.target ).parent();

			// Remove class from all button filter elements first.
			this.buttonFilter.removeClass( 'is-selected' );

			// Add 'is-selected' class to the selected button element.
			targetEl.addClass( 'is-selected' );

			// Add 'is-open' class to show the filter container.
			this.dropdownFilterContainer.addClass( 'is-open' );

			this.displayDropdownItems( targetEl );

			// Scroll the window to get the buttons in view.
			this.scrollToElement( this.dropdownFilterContainer, -60, -80, -100 );
		}

		/**
		 * Provided with the targetEl, check if it has the correct data
		 * attributes to assist with showing and hiding drop down child terms.
		 *
		 * @param {jQuery} targetEl
		 */
		displayDropdownItems( targetEl ) {

			targetEl = $( targetEl );

			if ( targetEl.length ) {

				// Clear all prev selected options.
				if ( this.selectedInputEl && this.selectedInputEl.length ) {
					this.resetOptions();
				}


				const termID       = targetEl.attr( 'data-term-id' );
				const allTermEls   = $( '[data-audience-type-parent-id]' );
				const childTermEls = $( `[data-audience-type-parent-id=${ termID }]` );

				if ( termID && allTermEls.length && childTermEls.length ) {
					// Hide all.
					allTermEls.removeClass( 'child-item' );

					this.dropdownFilterHeadings.hide();
					this.dropdownFilterDescs.hide();
					this.dropdownFilterContainer.find( '.heading-' + termID ).show();
					this.dropdownFilterContainer.find( '.description-' + termID ).show();

					// Show specific term items related to teh selected parent term ID.
					childTermEls.addClass( 'child-item' );
				}
			}
		}

		scrollToElement = ( element, mobileOffset = 0, tabletOffset = 0, desktopOffset = 0 ) => {

			const elementTopPos = element.offset().top;
			let topPos          = elementTopPos;

			if ( 758 > window.innerWidth ) {

				topPos = elementTopPos + mobileOffset;

			} else if ( 758 < window.innerWidth && 1080 > window.innerWidth ) {

				topPos = elementTopPos + tabletOffset;

			} else {

				topPos = elementTopPos + desktopOffset;

			}

			window.scrollTo( {
				top: topPos,
				behavior: 'smooth'
			} );

		};

		/**
		 * Show/hide the dropdown.
		 *
		 * @param event
		 */
		toggleDropdown( event ) {
			this.selectBox.toggleClass( 'is-open' );
		}

		/**
		 * Select option.
		 *
		 * @param {Object} event Event.
		 */
		selectOption( event ) {

			// Get the id of the selected input element, using for attribute.
			this.selectedElId    = $( event.target ).attr( 'for' );
			this.selectedInputEl = $( `#${ this.selectedElId }` );

			this.checkTheSelectedItem();
			this.setSelectedIdToHiddenInput();
			this.toggleIsSelectedClass( event.target );

			const termID = this.selectedInputEl.attr( 'data-term-id' );

			if ( termID && postURLs[ termID ] ) {
				this.submitButtonEl.attr( 'href', postURLs[ termID ] );
			}
		}

		/**
		 * Reset the option fields.
		 *
		 * @param {Object} event Event.
		 */
		resetOptions( event ) {

			// Get the id of the selected input element, using for attribute.
			this.selectedElId    = 'select-box-input-0';
			this.selectedInputEl = $( `#${ this.selectedElId }` );


			this.checkTheSelectedItem();
			this.setSelectedIdToHiddenInput();

			// Remove selected classNames.
			this.selectBox.removeClass( 'is-selected' );
			this.options.removeClass( 'is-selected' );

			this.selectedInputEl.trigger( 'click' );

			this.selectBox.removeClass( 'is-open' );
			this.submitButtonEl.attr( 'href', '#' );
		}

		checkTheSelectedItem() {
			// Remove checked attributed from all elements, so that we can add it only to the one that is selected.
			this.selectedBoxInputEls.attr( 'checked', false );

			// Add the checked attribute to the element that is selected.
			this.selectedInputEl.attr( 'checked', 'checked' );
		}

		setSelectedIdToHiddenInput() {
			// Get the selected term id.
			const selectedTermId = this.selectedInputEl.val();

			// Set the id of the selected term in the hidden input value.
			this.hiddenInput.val( selectedTermId );
		}

		toggleIsSelectedClass( selectedLabelEl ) {
			// Toggle isSelected Class for selectBox
			this.selectBox.addClass( 'is-selected' );

			// Remove isSelected class from the all the labels and to the one selected, so that we can add a background color to it.
			this.options.removeClass( 'is-selected' );
			$( selectedLabelEl ).addClass( 'is-selected' );
		}


		set submitButtonEl( value ) {
			this._submitButtonEl = value;
		}

		set selectedElId( value ) {
			this._selectedElId = value;
		}

		set selectedInputEl( value ) {
			this._selectedInputEl = value;
		}


		get submitButtonEl() {
			return this._submitButtonEl;
		}

		get selectedElId() {
			return this._selectedElId;
		}

		get selectedInputEl() {
			return this._selectedInputEl;
		}

	}

	new Filter();

} )( jQuery );
